<script lang="ts" generics="TValues, TValue extends unknown">
    import type { Field, Form } from '@jmvdevelop/svelte-form';
    import { fade } from 'svelte/transition';
    import FieldErrors from '$components/Form/FieldErrors.svelte';
    import { cx } from '$lib/utils/cx.js';
    import { safe } from '$lib/utils/string';
    import { createDialog } from '@melt-ui/svelte';
    import { melt } from '@melt-ui/svelte';
    import type { CreateDialogProps } from '@melt-ui/svelte';

    export let form: Form<TValues, string>;
    export let field: Field<TValues, TValue>;
    export let label: string;
    export let description: string | null = null;
    export let required: boolean = false;

    export let prefixId: string = '';
    export let id: string | null = null;

    let className: string = '';
    export { className as class };

    export let chevron = true;

    export let defaultClass = cx(
        'px-[20px] py-[20px]',
        'border border-solid border-l-0 border-r-0 border-b-0 border-t first:border-t-0 border-gray-350',
        'btn-reset text-left',
        'flex flex-col justify-center',
        'w-full',
        'focus:outline-none focus:bg-white focus:ring-2 ring-brand-blue ring-inset focus:rounded-[8px]',
    );

    export let defaultLabelClass = 'text-14 text-gray-800 font-bold block flex-1';
    export let labelClass = '';

    export let defaultDescriptionClass = 'text-12 text-gray-500 font-medium';
    export let descriptionClass = '';

    export let createDialogOpts: CreateDialogProps = {};

    const dialog = createDialog({
        preventScroll: true,
        ...createDialogOpts,
    });

    const {
        elements: { trigger },
    } = dialog;

    $: isAsyncValidating = form.stores().isAsyncValidating(field);
    $: effectiveId = safe`${prefixId}-${id ?? form.getFieldId(field)}`;

    interface $$Slots {
        description: {
            class: string;
        };
        default: {
            form: typeof form;
            field: typeof field;
            label: typeof label;
            dialog: typeof dialog;
            id: typeof id;
        };
    }
</script>

<button type="button" class={cx(defaultClass, className)} use:melt={$trigger}>
    <span class="flex flex-col w-full gap-y-[4px]">
        <span class={cx('flex gap-x-[8px]')}>
            <span class={cx(defaultLabelClass, labelClass)}>
                {label}{required ? '*' : ''}
            </span>

            {#if chevron}
                <i
                    class="tnp tnp-chevron-right flex items-center text-16"
                    aria-hidden={true}
                />
            {/if}
        </span>
        <slot name="description" class={cx(defaultDescriptionClass, descriptionClass)}>
            {#if description != null}
                <span class={cx(defaultDescriptionClass, descriptionClass)}
                    >{description}</span
                >
            {/if}
        </slot>
    </span>

    {#if $isAsyncValidating}
        <span in:fade class="text-orange-600">Vérification...</span>
    {/if}

    <FieldErrors {form} {field} />
</button>

<slot {form} {field} {label} {dialog} id={effectiveId} />
